import styled from 'styled-components';

import Picture from 'components/picture';
import BlockRenderer from 'components/sanity-block-renderer';

export const OFFER_WIDTH = '146px';
export const DESKTOP_OFFER_WIDTH = '250px';

/**
 * offers
 */
export const OffersList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  max-width: ${Styles.layout.sectionMaxWidth};
  width: 100%;

  ${Styles.mobile`
    flex-direction: column;
    margin: 0 auto;
  `}
`;

export const LoadingContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: 18rem;
  width: 100%;
`;

/**
 * offer
 */

export const WRAPPER_SHARED_STYLES = `
  height: 100%;
  border-radius: ${Styles.borderRadius};
  box-shadow: ${Styles.boxShadow};
  min-height: 290px;
  margin: 0.25rem 0rem;
  display: flex;
  flex-direction: column;
`;

export const Wrapper = styled.button<{ $isGridLayout?: boolean }>`
  ${WRAPPER_SHARED_STYLES}
  appearance: none;
  border: none;
  padding: 0;
  font-size: inherit;
  font-family: ${Styles.fontFamily.alternative};
  position: relative;
  text-align: left;
  background: transparent;
  z-index: 0;
  user-select: none;
  cursor: pointer;
  background-color: ${Styles.color.white};
  transition: box-shadow 0.3s;
  min-width: ${OFFER_WIDTH};

  &:hover {
    box-shadow: 0px 0px 0px 3px ${Styles.color.grey.four};
  }

  ${Styles.desktop`
    width: ${DESKTOP_OFFER_WIDTH};
  `}
`;

/**
 * Wraps The top offer content to allow for keeping at the
 * top of the content area while flex justifying space between
 * to keep other content at the bottom.
 */
export const OfferContentWrap = styled.div`
  width: 100%;
  margin-bottom: 0.5rem;
`;

export const Heading = styled.h2`
  color: ${Styles.color.primary};
  font-family: ${Styles.fontFamily.alternative};
  font-size: 1.25rem;
  line-height: 0.95;
  font-weight: 600;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;

  ${Styles.desktop`
    font-size: 1.5rem;
  `}
`;

/**
 * Offer Expiration text
 */
export const OfferExpiration = styled.p`
  color: ${Styles.color.black};
  font-family: ${Styles.fontFamily.alternative};
  font-size: 0.75rem;
  line-height: 1.1;
  margin-block-start: 0.5em;
  margin-block-end: 0.5em;

  ${Styles.desktop`
    font-size: 0.9rem;
  `}
`;

export const OfferContent = styled.div`
  align-items: flex-start;
  display: flex;
  flex-flow: column nowrap;
  flex: auto;
  justify-content: space-between;
  padding: 1rem;
  width: 100%;
`;

const DESCRIPTION_SHARED_STYLES = `
  margin: 0.5rem 0;

  ${Styles.desktop`
    margin: 1rem 0;
  `}
`;

export const SanityDescription = styled(BlockRenderer)`
  p {
    ${DESCRIPTION_SHARED_STYLES}
    color: ${Styles.color.black};
    font-family: ${Styles.fontFamily.alternative};
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.1;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
`;

export const IMG_SHARED_STYLES = `
  border-radius: ${Styles.borderRadius} ${Styles.borderRadius} 0 0;
  ${`height: calc(${OFFER_WIDTH} / 1.5);`}

  ${Styles.desktop`
    width: ${DESKTOP_OFFER_WIDTH};
    height: calc(${DESKTOP_OFFER_WIDTH} / 1.5);
  `}
`;

export const StyledPicture = styled(Picture)`
  ${IMG_SHARED_STYLES}
  position: relative;
  width: 100%;
`;

export const GridOffersWrapper = styled.div`
  margin: 2rem 1rem;
  display: grid;
  ${`grid-template-columns: repeat(auto-fit, minmax(${OFFER_WIDTH}, 1fr));`}
  grid-gap: 1rem;
  justify-content: center;
  ${Styles.desktop`
    grid-template-columns: repeat(auto-fit, minmax(${DESKTOP_OFFER_WIDTH}, max-content));
  `}
`;

/**
 * Offer Skeleton
 */

export const OfferSkeletonWrapper = styled.div<{ $isGridLayout?: boolean }>`
  ${WRAPPER_SHARED_STYLES}
  width: ${p => (p.$isGridLayout ? '100%' : OFFER_WIDTH)};
  ${Styles.desktop`
    height: 310px;
    width: ${DESKTOP_OFFER_WIDTH};
  `}
`;

export const OfferSkeletonButtonWrapper = styled.div`
  border-radius: 500px;
  margin: 0 auto;
  overflow: hidden;
  line-height: 1;
  width: 100%;
  ${Styles.desktop`
    width: 218px;
  `}
`;

export const OfferSkeletonDescription = styled.div`
  ${DESCRIPTION_SHARED_STYLES}
  font-size: 0.9rem;
  line-height: 1.2;
`;

export const OfferSkeletonImageWrapper = styled.div`
  line-height: 1;

  & span {
    ${IMG_SHARED_STYLES}
  }
`;
